/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CountryInfo } from './country-info';
import { OrganizationInfo } from './organization-info';


export interface CurrentUserInfoResponse { 
    id: string;
    userName: string;
    email: string;
    telegramLogin: string;
    telegramChatId: string;
    isTwoFactorEnabled: boolean;
    isAuthenticatorEnabled: boolean;
    lastPasswordChangedDate: string;
    country?: CountryInfo;
    organization?: OrganizationInfo;
    permissions?: Array<string> | null;
    availableAccountIds?: Array<string> | null;
}

